import { Pipe, PipeTransform } from '@angular/core';
import { ITokenPlans } from '@http/interfaces/supported-token';

@Pipe({
  name: 'coinProgressStyle',
})
export class CoinProgressStylePipe implements PipeTransform {
  transform(coin: ITokenPlans, totalBalance: number): any {
    if ((coin.balance_currency / totalBalance) * 200 < 1) {
      return {
        width: '5px',
      };
    }
    const style = {};

    const percent = (coin.balance_currency * 100) / totalBalance;
    Object.assign(style, { width: percent + '%' });
    return style;
  }
}
